import { Recipe } from '$tablet-app/src/app/recipes/types';
import { palette, spacing } from '$tablet-app/src/app/theme';
import { joinArrayBy } from '$tablet-app/src/app/utils/arrays';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC, useState } from 'react';
import {
  LayoutChangeEvent,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  useWindowDimensions,
  View,
  ViewStyle,
} from 'react-native';
import Button from '../Button';
import Text from '../Text';
import RecipeImage from './RecipeImage';

interface RecipePanelProps {
  recipe: Recipe;
  onClick?: (recipe: Recipe) => void;
  onDelete?: (id: string) => void;
  isWidget?: boolean;
  style?: StyleProp<ViewStyle>;
}

const RecipePanel: FC<RecipePanelProps> = (props) => {
  const { recipe, onClick, onDelete, style: styleOverride } = props;

  const { width } = useWindowDimensions();
  const isSmallScreen = width < 500;

  const [imageWidth, setImageWidth] = useState<number>(0);
  const handleImageLayout = ({ nativeEvent }: LayoutChangeEvent) => {
    const { width } = nativeEvent.layout;
    setImageWidth(width);
  };

  const recipeCardStyle = isSmallScreen
    ? styles.recipeCardSmall
    : styles.recipeCard;

  const recipeTitleStyle = isSmallScreen
    ? styles.recipeTitleSmall
    : styles.recipeTitle;

  return (
    <TouchableOpacity
      onPress={() => onClick && onClick(recipe)}
      disabled={!onClick}
    >
      <View
        style={[recipeCardStyle, styleOverride]}
        onLayout={handleImageLayout}
      >
        <RecipeImage
          recipe={recipe}
          isSmallScreen={isSmallScreen}
          imageWidth={imageWidth}
        />
        <View style={recipeTitleStyle}>
          <Text style={styles.recipeCategoryLabel}>
            {recipe.dishType?.label}
            {recipe.specialDiets?.length
              ? joinArrayBy(recipe.specialDiets, 'label')
              : null}
          </Text>
          <Text style={styles.recipeName}>{recipe.name}</Text>
        </View>
        {onDelete ? (
          <Button
            preset="text"
            style={styles.deleteButton}
            onPress={() => onDelete(recipe.id)}
          >
            <FontAwesomeIcon
              size={20}
              icon="times"
              style={{ color: palette.dim }}
            />
          </Button>
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

// Styles
const styles = StyleSheet.create({
  recipeCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: `${palette.Orange_crayola}26`,
    borderRadius: 10,
    padding: spacing[3],
    margin: spacing[3],
  },
  recipeCardSmall: {
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: `${palette.Orange_crayola}26`,
    borderRadius: 10,
    padding: spacing[3],
    paddingTop: spacing[3],
    margin: spacing[3],
    marginLeft: 0,
  },
  recipeTitle: {
    flexDirection: 'column',
    marginLeft: spacing[3],
    maxWidth: '50%',
  },
  recipeTitleSmall: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: spacing[3],
    maxHeight: '50%',
  },
  recipeCategoryLabel: {
    color: palette.Orange_crayola,
    marginBottom: spacing[2],
    maxWidth: '80%',
  },
  recipeName: {
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'left',
    maxWidth: '80%',
  },
  deleteButton: {
    position: 'absolute',
    top: spacing[0],
    right: spacing[0],
  },
});

export default RecipePanel;
